import { render, staticRenderFns } from "./AiPhotoValidationList.vue?vue&type=template&id=7bf913ff&"
import script from "./AiPhotoValidationList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiPhotoValidationList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports